import { observer } from "mobx-react-lite";
import VerifyPaymentContent from "../../components/financier/wallets/VerifyPaymentContent";
import FinancierSharedView from "../shared/FinancierSharedView";

export default observer(function VerifyPayment() {
  return <FinancierSharedView mainContent={<VerifyPaymentContent />} />;
});
